import Component from '@glimmer/component';
import { service } from '@ember/service';
import AbilitiesService from 'donor-elf-web/services/abilities';
import HeaderBar from 'donor-elf-web/components/header-bar';

export default class TasksHeader extends Component {
  @service declare abilities: Abilities;

  get headerBarLinks() {
    if (this.abilities.hasAbility('assign_tasks')) {
      return [
        {
          route: 'funds.fund.tasks.v2.assigned',
          models: [],
          label: 'List',
        },
        {
          route: 'funds.fund.tasks.v2.summary',
          models: [],
          label: 'Summary',
        },
        {
          route: 'funds.fund.tasks.v2.by-contact',
          models: [],
          label: 'by Contact',
        },
      ];
    } else {
      return [
        {
          route: 'funds.fund.tasks.v2.index',
          models: [],
          label: 'List',
        },
        {
          route: 'funds.fund.tasks.v2.by-contact',
          models: [],
          label: 'by Contact',
        },
      ];
    }
  }

  <template>
    <HeaderBar @links={{this.headerBarLinks}} />
  </template>
}
